<template>
  <div>
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">Liste des sms / {{totalPrix}}€</h3>
        </div>
        <div class="card-toolbar">
          <a class="btn btn-icon btn-sm btn-primary mr-1"  href="/#/lead/nouveau">
            <i class="icon-md fas fa-plus"></i>
          </a>
          <a class="btn btn-icon btn-sm btn-danger mr-1"  v-b-modal.search>
            <i class="icon-md fas fa-search"></i>
          </a>
        </div>
      </div>
      <div class="card-body">
        <b-row>
          <b-col md="1">
            <select class="form-control" v-model="datatable.limitPage" @change="datatableInit">
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </b-col>
        </b-row>
        <b-table responsive striped hover ref="table" :items="datatable.data" :fields="fields" @sort-changed="sortChanged" show-empty empty-text="Il n'y a aucun enregistrement à afficher">
          <template #cell(date_create)="data">
            {{ $store.back.timestampToDate(data.value) }}
          </template>
          <template #cell(_id)="data">
            <a class="btn btn-icon btn-sm btn-danger mr-1"  @click="openDetail(data.item)">
              <i class="icon-md fas fa-eye"></i>
            </a>
          </template>
        </b-table>
        <b-pagination size="lg" align="center" v-model="datatable.currentPage" @change="changePage" :total-rows="datatable.totalRow" :per-page="datatable.limitPage" aria-controls="itemList"></b-pagination>
      </div>
    </div>
    <b-modal id="search" title="Recherche" size="xl" ref="myModalDeleteRef">
      <div class="row">
        <div class="form-group col-md-4" v-for="(field,i) in fields.filter(f => f.searchable == true)" :key="i">
          <label>{{field.label}}</label>
          <input type="text" :placeholder="'Rechercher par '+field.label" :data-column="field.key" class="form-control">
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" class="float-right" @click="searchInit">
            Recherche
          </b-button>
          <b-button variant="danger" class="float-right mr-2" @click="$refs.myModalDeleteRef.hide();">
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal id="detail" title="Detail de sms" size="xl" ref="myModalDetail">
      <div class="row">
        <div class="form-group col-md-3">
          <label>ID</label>
          <input type="text" v-model="detail.id" class="form-control" readonly>
        </div>
        <div class="form-group col-md-3">
          <label>Destinataire</label>
          <input type="text" v-model="detail.data.data.payload.to.phone_number" class="form-control" readonly>
        </div>
        <div class="form-group col-md-3">
          <label>Prix</label>
          <input type="text" v-model="detail.data.data.payload.cost.amount" class="form-control" readonly>
        </div>
        <div class="form-group col-md-3">
          <label>Date</label>
          <input type="text" :value="$store.back.timestampToDate(detail.date_create)" class="form-control" readonly>
        </div>
        <div class="form-group col-md-12">
          <label>Message</label>
          <b-form-textarea id="textarea" v-model="detail.data.data.payload.text" rows="3" max-rows="6" readonly></b-form-textarea>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="danger" class="float-right mr-2" @click="$refs.myModalDetail.hide();">
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>

export default {
  data(){
    return {
      items: [],
      fields: [
        {
          key: 'id',
          label: '#',
          sortable:true,
          searchable:true
        },
        {
          key: 'data.data.payload.to.phone_number',
          label: `Destinataire`,
          sortable:false,
          searchable:false
        },
        {
          key: 'data.data.payload.cost.amount',
          label: 'Prix',
          sortable:false,
          searchable:false
        },
        {
          key: 'date_create',
          label: 'Date',
          sortable:false,
          searchable:true
        },
        {
          key: '_id',
          label: '',
          sortable:false,
          searchable:false
        },
      ],
      datatable:{
        currentPage: 1,
        nextPage: 2,
        previousPage: 0,
        limitPage: 20,
        totalRow: 0,
        data: []
      },
      sort:{
        field: 'id',
        value: 'DESC'
      },
      searchQuery:null,
      detail:{
        "_id": {
          "$oid": "60ed36ee62675833b0210133"
        },
        "data": {
          "data": {
            "event_type": null,
            "id": null,
            "occurred_at": null,
            "payload": {
              "cc": [],
              "completed_at": null,
              "cost": {
                "amount": null,
                "currency": null,
              },
              "direction": null,
              "encoding": null,
              "errors": [],
              "from": {
                "carrier": null,
                "line_type": null,
                "phone_number": null,
              },
              "id": null,
              "media": [],
              "messaging_profile_id": null,
              "organization_id": null,
              "parts": null,
              "received_at": null,
              "record_type": null,
              "sent_at": null,
              "tags": [],
              "text": null,
              "to":{
                "carrier": null,
                "line_type": null,
                "phone_number":null,
                "status": null,
              },
              "type": null,
              "valid_until": null,
              "webhook_failover_url": null,
              "webhook_url": null,
            },
            "record_type": null
          },
          "meta": {
            "attempt": null,
            "delivered_to": null,
          }
        },
        "date_create": null,
        "id": null
      }
    };
  },
  components: {
  },
  watch: {
  },
  beforeMount() {
  },
  methods: {
    datatableInit: function(){
      var the = this
      this.$store.back.ajax('/telnyx/liste?'+this.query,null,(res) => {
        the.datatable = res;
      });
    },
    sortChanged(e){
      this.sort = {
        field: e.sortBy,
        value: e.sortDesc === true ? "DESC" : "ASC"
      };
      this.datatable.data = [];
      this.datatableInit();
    },
    changePage(e){
      this.datatable.currentPage = e;
      this.datatableInit();
    },
    searchInit(){
      this.datatable.currentPage = 1;
      let query = {};
      let inputs  = document.querySelectorAll('[data-column]');
      inputs.forEach(elt => {
        let value  = elt.value;
        let key = elt.dataset.column;
        query[key] = value
      });
      if(Object.entries(query).length > 0){
        this.searchQuery = encodeURI(JSON.stringify(query));
      }else{
        this.searchQuery = null;
      }
      this.$refs.myModalDeleteRef.hide();
      this.datatableInit();
    },
    openDetail(obj){
      this.detail = obj;
      this.$refs.myModalDetail.show();
    }
  },
  computed: {
    query: function(){
      var sort = this.sort.field === null ? null : encodeURI(JSON.stringify(this.sort));
      return 'page='+this.datatable.currentPage+'&limit='+this.datatable.limitPage+'&sort='+sort+'&search='+this.searchQuery;
    },
    totalPrix(){
      var total = 0
      this.datatable.data.forEach((item) => {
          total += parseFloat(item.data.data.payload.cost.amount)
      });
      return total.toFixed(3);
    }
  },
  mounted() {
    this.datatableInit();
  }
};
</script>
